import DiamondFilled from '../src/DiamondFilled';
export default DiamondFilled;
